import axios from 'axios';

export default {
    fetchForOptimizedPaintList(workstationId, optimizedPaintListId) {
        return axios.get(`[API]/target-times/${workstationId}`, {
            params: {
                optimizedPaintListId,
            },
        });
    },

    postHistoryForOptimizedPaintList(
        workstationId,
        optimizedPaintListId,
        employeeId,
        startedAt,
        stoppedAt
    ) {
        return axios.post(`[API]/target-times/${workstationId}/history`, {
            optimizedPaintListId,
            employeeId,
            startedAt,
            stoppedAt,
        });
    },
};
